import React from 'react';
import styles from './HeroBanner.module.css';

const HeroBanner = ({ title, body, phone }) => {
    return (
        <div className={styles.banner}>
            {title && <p className={`${styles.title}`}>{title}</p>}
            {body && <p className={`${styles.body}`}>{body}</p>}
            {phone && <p className={`${styles.phone}`}>Call {phone}</p>}
        </div>
    );
};

export default HeroBanner;
